"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminLinkDto = instanceOfAdminLinkDto;
exports.AdminLinkDtoFromJSON = AdminLinkDtoFromJSON;
exports.AdminLinkDtoFromJSONTyped = AdminLinkDtoFromJSONTyped;
exports.AdminLinkDtoToJSON = AdminLinkDtoToJSON;
exports.AdminLinkDtoToJSONTyped = AdminLinkDtoToJSONTyped;
/**
 * Check if a given object implements the AdminLinkDto interface.
 */
function instanceOfAdminLinkDto(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function AdminLinkDtoFromJSON(json) {
    return AdminLinkDtoFromJSONTyped(json, false);
}
function AdminLinkDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'url': json['url'],
    };
}
function AdminLinkDtoToJSON(json) {
    return AdminLinkDtoToJSONTyped(json, false);
}
function AdminLinkDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'url': value['url'],
    };
}
//# sourceMappingURL=AdminLinkDto.js.map